"use client"

import { ApolloLink, HttpLink } from "@apollo/client"
import {
  ApolloClient,
  ApolloNextAppProvider,
  InMemoryCache,
  SSRMultipartLink,
} from "@apollo/client-integration-nextjs"
import { onError } from "@apollo/client/link/error"
import { createAzureInsightsLink } from "./azureInsightsLink"
import {
  createErrorContext,
  createIsraeliTimestamp,
  logGraphQLErrors,
  logNetworkError,
} from "./errorLink"
import generatedIntrospection from "./introspection-result.json"

// For client-side operations, use the client-facing GraphQL URL
const GRAPHQL_URL = process.env.GRAPHQL_URL

function makeClient() {
  const httpLink = new HttpLink({
    uri: GRAPHQL_URL,
  })

  const azureInsightsLink = createAzureInsightsLink()

  const errorLink = onError(({ graphQLErrors, operation, networkError }) => {
    try {
      const errorContext = createErrorContext(operation, GRAPHQL_URL)

      if (graphQLErrors) {
        logGraphQLErrors(graphQLErrors, errorContext)
      }

      if (networkError) {
        logNetworkError(networkError, errorContext)
      }
    } catch (errorHandlingError) {
      // Fallback error logging if our error handling fails
      console.error("=== ERROR HANDLER FAILED ===")
      console.error("Error handling error:", errorHandlingError)
      console.error("Original GraphQL errors:", graphQLErrors)
      console.error("Original network error:", networkError)
      console.error("Operation:", operation)
      console.error("GraphQL URL:", GRAPHQL_URL)
      console.error("Timestamp:", createIsraeliTimestamp())
      console.error("==============================")
    }
  })

  return new ApolloClient({
    cache: new InMemoryCache({
      possibleTypes: generatedIntrospection.possibleTypes,
    }),
    link:
      typeof window === "undefined"
        ? ApolloLink.from([
            new SSRMultipartLink({
              stripDefer: true,
            }),
            azureInsightsLink.concat(errorLink).concat(httpLink),
          ])
        : azureInsightsLink.concat(errorLink).concat(httpLink),
  })
}

export function ApolloWrapper({ children }) {
  return (
    <ApolloNextAppProvider makeClient={makeClient}>
      {children}
    </ApolloNextAppProvider>
  )
}
